import React from "react";
import {
    IGrpZoneamento,
    IPerguntasZoneamento,
} from "../../../../shared/interfaces/IProperties";
import { UsoSolo } from "../uso-solo";
import { DivisorPeB } from "../divisor";
import { decodeAndSplitByBr } from "../helpers/decodeAndSplit";

interface ZonUsoProps {
    questions?: IPerguntasZoneamento[];
    zoneamento: IGrpZoneamento;
}

export const AraucariaZonUso: React.FC<ZonUsoProps> = ({
    questions,
    zoneamento,
}) => {
    const arrayOfQuestions = questions;
    return (
        <div>
            {Object.keys(zoneamento).length > 0 && (
                <>
                    <DivisorPeB />
                    <h3>{zoneamento.guia.toUpperCase()}</h3>
                    <span>{decodeAndSplitByBr(zoneamento.obs)}</span>
                </>
            )}
            {arrayOfQuestions && (
                <table className="w-full table-auto border-2 border-black">
                    <thead className="border-t border-2 border-black">
                        <tr className="bg-gray-300 border">
                            <th
                                style={{
                                    width: "400px",
                                }}
                            >
                                Nome
                            </th>
                            <th
                                style={{
                                    width: "150px",
                                }}
                            >
                                Quantidade
                            </th>
                            <th>Observação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {arrayOfQuestions.map(
                            ({ texto, valor, observacao }) => {
                                return (
                                    <tr
                                        className="border-2 border-black"
                                        key={`${texto}-${valor}-${observacao}`}
                                    >
                                        <td
                                            style={{
                                                border: "1px solid black",
                                            }}
                                        >
                                            {texto}
                                        </td>
                                        <td
                                            style={{
                                                border: "1px solid black",
                                            }}
                                        >
                                            <p>{valor}</p>
                                        </td>
                                        <td>
                                            <span>
                                                {decodeAndSplitByBr(observacao)}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            )}
            {Object.keys(zoneamento).length > 0 && (
                <UsoSolo zoneamento={zoneamento} />
            )}
        </div>
    );
};
